import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';
import validators from './common/validators';
import Routes from './Routes';
import { withRouter } from 'react-router-dom';
import { useAppLoadingInfo } from './hooks/useAppLoadingInfo';
import Message from './components/Message';
import { makeStyles } from '@material-ui/styles';
import { trackPageView } from './helpers';
import { useDispatch } from 'react-redux';
import {
  fetchStripeProducts,
  fetchStripePublishableKey
} from './redux/features/configuration/configurationSlice';

validate.validators = {
  ...validate.validators,
  ...validators
};
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    minHeight: '100vh',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      minWidth: '58vh'
    }
  }
}));
const App = ({ history, location }) => {
  const { isLoading, isLogin } = useAppLoadingInfo({ history });
  const dispatch = useDispatch();

  // Fetch Stripe configuration on app load
  useEffect(() => {
    dispatch(fetchStripeProducts());
    dispatch(fetchStripePublishableKey());
  }, [dispatch]);

  // Track page views when location changes
  useEffect(() => {
    if (location && location.pathname) {
      trackPageView(location.pathname, document.title);
    }
  }, [location]);
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Routes isLoadingApp={isLoading} isLogin={isLogin} />
      <Message />
    </div>
  );
};

App.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export default withRouter(App);
